"use client";

import { usePathname } from "next/navigation";
import { ReactNode } from "react";

interface PageTransitionProps {
  children: ReactNode;
}

/**
 * Remounts subtree on route change so client state resets cleanly.
 * Avoids a full-screen overlay (removed): it delayed first paint by >1s and hurt FCP/LCP/CLS.
 */
const PageTransition = ({ children }: PageTransitionProps) => {
  const pathname = usePathname();
  return <main key={pathname}>{children}</main>;
};

export default PageTransition;
